import { ProcessedEvent } from '@aldabil/react-scheduler/types';
import ScheduleCanlendar from '@src/components/schedule/calendar';
import { useCallback, useEffect, useState } from 'react';
import placeApi from '@src/services/api/place';
import useBookingSchedule from '@src/hooks/useBookingSchedule';
import dayjs from 'dayjs';
import styled from 'styled-components';
import { PlaceListType } from '@src/types/place';
import { MenuItem, Select } from '@mui/material';

const Container = styled.div``;

const SelectWrap = styled.div`
  display: flex;
  justify-content: end;
  gap: 12px;
  margin-bottom: 20px;
  > div {
    width: 200px;
  }
`;

const NOT_DISPLAY_PLACE = ['1020094'];

export default function ClubBookingSchedule() {
  const [selectDate, SetSelectDate] = useState(new Date(dayjs().add(1, 'month').format()));
  const [place, setPlace] = useState<string>();
  const [placeList, setPlaceList] = useState<PlaceListType[]>([]);
  const [status, setStatus] = useState<'AFTER' | 'BEFORE'>();
  const { list, loading, colors, resource } = useBookingSchedule(selectDate, place, status);

  const getPlaceList = async () => {
    const { data } = await placeApi.getList();
    setPlaceList(data);
  };

  const handleChangeTargetMonth = useCallback((date: Date) => {
    SetSelectDate(date);
  }, []);

  useEffect(() => {
    getPlaceList();
  }, []);

  return (
    <Container>
      <SelectWrap>
        <div>
          <Select value={place} onChange={event => setPlace(event.target.value as string)} size="small" fullWidth>
            <MenuItem value={undefined}>All</MenuItem>
            {placeList
              .filter(p => !NOT_DISPLAY_PLACE.some(id => id === p.business_id))
              .map(p => (
                <MenuItem key={p.business_id} value={p.business_id}>
                  {p.business_name}
                </MenuItem>
              ))}
          </Select>
        </div>
        <div>
          <Select
            value={status}
            onChange={event => setStatus(event.target.value as typeof status)}
            size="small"
            fullWidth
          >
            <MenuItem value={undefined}>All</MenuItem>
            <MenuItem value="BEFORE">예약 대기</MenuItem>
            <MenuItem value="AFTER">예약 완료</MenuItem>
          </Select>
        </div>
      </SelectWrap>
      <ScheduleCanlendar
        event={list}
        resource={resource}
        loading={loading}
        selectDate={selectDate}
        handleChange={handleChangeTargetMonth}
      ></ScheduleCanlendar>
    </Container>
  );
}
